import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Descriptions, Row, Select, Skeleton, Tag } from 'antd';
import { Link } from 'react-router-dom';
import capitalize from 'lodash/capitalize';
import IntlMessages from '../../../../layout/components/lang/IntlMessages';
import { DATE_TIME_FORMAT, EMPTY_VALUE_PLACEHOLDER } from '../../../../const/system';
import { countries as countryOptions } from '../../../../const/countries';
import urlPagePushNotificationDetails from '../../../../urls/urlPagePushNotificationDetails';
import getFormattedDate from '../../../../lib/getFormattedDate';
import useCheckMobileScreen from '../../../../app/hooks/useCheckMobileScreen';
import PublishedTag from '../../../../components/PublishedTag';
import CollapsibleText from '../../../../components/CollapsibleText';
import StatusTag from '../../../../components/StatusTag';



const NotificationScheduleDetailsCard = ({
  data = {},
  isLoadingCard = false,
  isFetching = false,
}) => {
  const isMobile = useCheckMobileScreen(600);
  const countries = countryOptions.map((option) => ({ ...option, disabled: true }));

  return (
    <Card
      loading={isLoadingCard}
      className="hp-border-color-black-40 hp-card-6"
      title={<IntlMessages id='structures-source-push-notification-schedule' />}
    >
      {isFetching ? (
        <Row gutter={16}>
          <Col span={20}>
            <Skeleton active />
          </Col>
        </Row>
      ) : (
        <Row gutter={[ 24, 24 ]}>
          <Col sm={24} md={18}>
            <Descriptions
              title={data?.push_notification?.title}
              layout={isMobile ? 'vertical' : 'horizontal'}
              bordered
              className="hp-mb-32"
              column={1}
            >
              <Descriptions.Item label="ID" className='width-20-vw'>
                <span style={{ wordBreak: 'keep-all' }}>{data?.id}</span>
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-push-notification" />}>
                <Link
                  to={urlPagePushNotificationDetails({ notificationId: data?.push_notification?.data?.id })}
                  target="_blank"
                >
                  <CollapsibleText text={data?.push_notification?.data?.title} />
                </Link>
              </Descriptions.Item>

              <Descriptions.Item label={<IntlMessages id="ui-general-published" />}>
                <PublishedTag
                  published={data?.is_published}
                  publishedDate={data?.published_at}
                />
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-scheduled-at" />}>
                {getFormattedDate(data?.scheduled_at, DATE_TIME_FORMAT)}
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-use-utc" />}>
                <StatusTag active={data?.use_utc_zero_time || false} />
              </Descriptions.Item>
              <Descriptions.Item style={{ width: '50%' }} label={<IntlMessages id="ui-general-min-version" />}>
                {data?.min_version || EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-max-version" />}>
                {data?.max_version || EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-platform" />}>
                {data?.platform?.length ? data?.platform?.map((item, index) => {
                  return (
                  // eslint-disable-next-line react/no-array-index-key
                    <Tag key={index} color="purple">{capitalize(item)}</Tag>
                  );
                }) : EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-languages" />}>
                {data?.languages?.length ? data?.languages?.map((item, index) => {
                  return (
                  // eslint-disable-next-line react/no-array-index-key
                    <Tag key={index} color="purple">{capitalize(item)}</Tag>
                  );
                }) : EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-countries" />}>
                {data?.countries?.length ? (
                  <Select
                    className="single-line-select w-full"
                    mode="multiple"
                    name='countries'
                    value={data?.countries}
                    options={countries}
                  />) : EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      )}
    </Card>
  );
};


NotificationScheduleDetailsCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    push_notification: PropTypes.object,
    use_utc_zero_time: PropTypes.bool,
    is_published: PropTypes.bool,
    min_version: PropTypes.string,
    max_version: PropTypes.string,
    scheduled_at: PropTypes.string,
    published_at: PropTypes.string,
    platform: PropTypes.array,
    countries: PropTypes.array,
    languages: PropTypes.array,
  }).isRequired,
  isLoadingCard: PropTypes.bool,
  isFetching: PropTypes.bool,
};

export default NotificationScheduleDetailsCard;
